import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {post,get,ddxGet,ddxPost} from './utils/http'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$ddxGet = ddxGet;
Vue.prototype.$ddxPost = ddxPost;

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
